
import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

export class HttpService {

	baseUrl: string;
	private http: any;
	private static instance: HttpService;

	constructor() {

		this.baseUrl = '/';

		this.http = axios.create({
			baseURL: this.baseUrl
		});

	}

	static getInstance() {

		if (!HttpService.instance) {
			HttpService.instance = new HttpService();
		}

		return HttpService.instance;

	}

	get(url: string) : AxiosPromise {
		return this.http.get(url);
	}

	post(url: string, config: AxiosRequestConfig) : AxiosResponse {
		return this.http.post(url);
	}

}



// WEBPACK FOOTER //
// ./services/http.service.ts